import { createCacheStore } from '@lib/utils/cache';
import { ShiftGeneratorResultService } from '@api/ShiftGeneratorResultService';

/*
 * ttlMs is zero because results are produced by the external runner
 * service: a task can regenerate server-side at any time, so reads
 * serve the last known result instantly but always revalidate in the
 * background — the cache only saves the loading flash, never
 * freshness here.
 */

/** Cached ShiftGeneratorResultService.getShiftGeneratorResult(departmentId, taskId) reads. */
export const shiftGeneratorResultCache = createCacheStore(
    'shiftGeneratorResult/result',
    ShiftGeneratorResultService.getShiftGeneratorResult,
    { ttlMs: 0 },
);

/** Cached ShiftGeneratorResultService.getCostPlan(departmentId, taskId) reads. */
export const costPlanCache = createCacheStore(
    'shiftGeneratorResult/costPlan',
    ShiftGeneratorResultService.getCostPlan,
    { ttlMs: 0 },
);

/** Cached ShiftGeneratorResultService.getEmployeesCriticalWorkMinutes(departmentId, taskId) reads. */
export const employeesCriticalWorkMinutesCache = createCacheStore(
    'shiftGeneratorResult/criticalWorkMinutes',
    ShiftGeneratorResultService.getEmployeesCriticalWorkMinutes,
    { ttlMs: 0 },
);

/** Cached ShiftGeneratorResultService.getResultBreaches(departmentId, taskId, rules) reads. */
export const resultBreachesCache = createCacheStore(
    'shiftGeneratorResult/breaches',
    ShiftGeneratorResultService.getResultBreaches,
    { ttlMs: 0 },
);

/** Drops all cached result data (run triggers, full clears). */
export const invalidateShiftGeneratorResultData = (): void => {
    shiftGeneratorResultCache.invalidateAll();
    costPlanCache.invalidateAll();
    employeesCriticalWorkMinutesCache.invalidateAll();
    resultBreachesCache.invalidateAll();
};
